// FE/src/pages/admin/BankAccountsAdministrationPage.jsx
import React, { useEffect } from "react";
import BankAccountTable from "components/tables/BankAccountTable.jsx";
import { useBreadcrumb } from "../../contexts/BreadcrumbContext.jsx";

export default function BankAccountsAdministrationPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Bankverbindungen", path: "/admin/bankaccounts" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <BankAccountTable
      pageTitle="Bankverbindungen"
      pageSubtitle="Hinterlegte Bankverbindungen der Kunden und Objekte"
    />
  );
}
